import React from 'react'
import { useDispatch } from 'react-redux'

import { datatableActions } from './store'

const DatatableResetFilter = () => {
	const dispatch = useDispatch()

	const handleResetFilter = () => {
		dispatch(datatableActions.resetFilter())
		dispatch(datatableActions.getData({ initial: true }))
	}

	return (
		<button onClick={handleResetFilter}>
			<i className="fal fa-times text-red-500 text-2xl" />
			{/*<span>Reset filters</span>*/}
			{/*<span className="fa-stack">*/}
			{/*    <i className="fal fa-filter fa-stack-1x"></i>*/}
			{/*    <i className="fal fa-slash fa-stack-1x"></i>*/}
			{/*</span>*/}
		</button>
	)
}

export default DatatableResetFilter
